export enum StorageKeys {
  API_USER_DATA = 'app_api_user_data',
  API_DISCHARGE_CARE_PLAN_DATA = 'app_discharge_care_plan_data'
}
